import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from 'primereact/button';
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { getDatesProduccion } from "../../../../../../Base/Services/Moment/Luxon";
import CalendarioOperativo from "../../../../../../Base/Components/Form/CalendarioOperativo";

// ------------------- CONSULTAS A LA API---------------------------
import { ObtenerRequisasAgrupadas } from "../../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";
import { getPersonalRecibeProducto } from "../../../../../../API/RRHH/Personal/PersonalRequests";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import AgregarSalidas from "./AgregarSalidas";
import RequisaMaterialCrud from "../../RequisasMateriales/RequisasMaterialesCRUD/RequisaMaterialCrud";

const ListadoSalidasMaterialesEnc = ({ actualizarScreen, MateriaPrima }) => {

  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [showDialogS, setShowDialogS] = useState(false);
  const [listadoR, setListadoR] = useState(null);  
  const [posicion, Posicion] = useState([]);  
  const [showDialogRM, setShowDialogRM] = useState(false);
  const [requisaToShow, setRequisaToShow] = useState(null);
  const [habilitar, setHabilitar] = useState(true);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const toast = useRef(null);
  const [personal, setPersonal] = useState([]);

  const [hiddenFinanzas, setHiddenFinanzas] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(30)
  );


  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Por favor, seleccione un rango de fechas válido."
      );
      return;
    }
    setLoading(true)
    const fechas = getDatesProduccion(dates);      
    const lista = await ObtenerRequisasAgrupadas(fechas);   
    let data
    
    if(MateriaPrima){
      data = lista.filter((i) => i.MateriaPrima === true)
    }else{
      data = lista.filter((i) => i.MateriaPrima !== true)
    }
    const personalTempo = await getPersonalRecibeProducto();
    setPersonal(personalTempo)
    setListadoR(data)
    setLoading(false)
  };

  const columns = [
    {
      field: "IdRequisaDet",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      frozen: "frozen",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialogS(true);
        setSelected(data);
      },
    },
    {
      field: "FechaDet",
      header: "Fecha",
      headerEn: "Date",
      className: "medium",
      body: (rowData) => rowData.FechaDet,
      frozen: "frozen",
      Format: "DateTime",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "medium",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
      onCellDoubleClicked: ({ data }) => {
        setShowDialogS(true);
        setSelected(data);
      },
    },
    {
      field: "Requisa",
      headerEn: "No. Material Requisition",
      header: "No. Requisa Material",
      className: "small",
      body: (rowData) => rowData.Requisa,
      Format: "Modal",
      align: "center",
      Sumary: "count",
      frozen: "frozen",
      onCellDoubleClicked: ({ data }) => {
        RequisaM(data.Requisa);
      },
    },
    {
      field: "CodigoProducto",
      header: "Codigo",
      headerEn: "Code",
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
      onCellDoubleClicked: ({ data }) => {
        setShowDialogS(true);
        setSelected(data);
      },
    },
    {
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "Xlarge",
      body: (rowData) => rowData.NombreProducto,
      onCellDoubleClicked: ({ data }) => {
        setShowDialogS(true);
        setSelected(data);
      },
    },
    {
      // Comment
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      body: (rowData) => rowData.UnitName,
    },
    {
      // Comment
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
    },
    {
      // Comment
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      // Comment
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
      body: (rowData) => rowData.UnitName,
    },
    {
      // Comment
      field: "Comentarios",
      header: "Comentario",
      headerEn: "Comment",
      className: "medium",
      body: (rowData) => rowData.UnitName,
    },
    {
      // Comment
      field: "UserNameEdit",
      header: "Usuario Creacion",
      headerEn: "Usuario Creacion",
      className: "medium",
      body: (rowData) => rowData.UnitName,
    },
    {
      header: "Usuario Autorizó",
      headerEn: "User Auth",
      field: "UserNameAutorizoSolicita",
      className: "small",
    },
    // {
    //   field: "PrecioL",
    //   header: "Precio L",
    //   headerEn: "Price L",
    //   Sumary: "sum",
    //   className: "small",
    //   Format: "Currency",
    //   hidden: hiddenFinanzas,
    // },
    // {
    //   field: "PrecioD",
    //   header: "Precio D",
    //   headerEn: "Price D",
    //   Sumary: "sum",
    //   className: "small",
    //   Format: "Currency",
    //   hidden: hiddenFinanzas,
    // },
    // {
    //   field: "MontoL",
    //   header: "Monto L",
    //   headerEn: "Monto L",
    //   className: "small",
    //   Sumary: "sum",
    //   Format: "Currency",
    //   hidden: hiddenFinanzas,
    // },
    // {
    //   field: "MontoD",
    //   Sumary: "sum",
    //   header: "Monto D",
    //   headerEn: "Monto D",
    //   className: "small",
    //   Format: "Currency",
    //   hidden: hiddenFinanzas,
    // },
    {
      header: "Inventario Pacas",
      headerEn: "Amount",
      field: "Quantity",
      Format: "Currency",
      Sumary: "sum",
      className: "small",
      frozen: true,
      alignFrozen: "right"
    },
    {
      header: "Solicitado",
      headerEn: "Amount",
      field: "Qty",
      Sumary: "sum",
      Format: "Currency",
      className: "Xsmall",
      frozen: true,
      alignFrozen: "right"
    },
    {
      header: "Despachado",
      headerEn: "Despachado",
      field: "QtySalida", //DESDE SALIDAS
      Sumary: "sum",
      Format: "Currency",
      className: "Xsmall",
      frozen: true,
      alignFrozen: "right"
    },
    {
      header: "Balance",
      headerEn: "Balance",
      field: "BalanceSalida",
      Format: "Currency",
      Sumary: "sum",
      className: "Xsmall",
      frozen: true,
      alignFrozen: "right"
    },

    {
      field: "",
      className: "colum-width-small",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: true,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-plus",
          tooltip: "Agregar Salida",
          onClick: (rowData) => {
            if(rowData?.IdRequisaDet){
              setShowDialogS(true);
              setSelected([rowData]);
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },

  ];

  const table = {
    Columns: columns,
    Data: listadoR,
    selected: selected,
    setSelected: (e) => setSelected(e),
    showModal: (e) => showModal(e),
  };

  const showModal = () => {
    setShowDialogRM(true);
  };

  const RequisaM = (Id) => {
    setRequisaToShow(Id);
    setShowDialogRM(true);
    showModal();
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && requisaToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialogRM(null);
          setRequisaToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialogRM(null);
      setRequisaToShow(null);
      setHabilitar(true);
    }
  };

  useEffect(() => {
    getInfo();
  }, []);
  
    
  return (
    <div>
      <Toast ref={toast} />
      <div className="d-flex gap-2 m-2">
        <h2>Listado de Requisas de Materiales</h2>
        <div className="d-flex">

          <CalendarioOperativo
            dates={dates}
            setDates={setDates}
            loading={loading}
            getInfo={getInfo}
          />

          <Button
            icon="pi pi-refresh"
            className="mx-2"
            onClick={(e) => {
              getInfo()
            }}
          />

          <Button
            icon="pi pi-plus"
            tooltip="Nueva"
            disabled={selected?.length !== 1}
            onClick={(e) => {
              setShowDialogS(true);
            }}
          />
        </div>
      </div>

      <div style={{ height: "74vh" }} id="#Dialog" >
        <Loader loading={loading} querySelector={"#Dialog"} />
        <AgGrid table={table} />
      </div>

      {showDialogS && (
        <AgregarSalidas
          selected={selected}
          setSelected={setSelected}
          showDialog={showDialogS}
          setShowDialog={setShowDialogS}
          getInfo={getInfo}
          actualizarScreen={actualizarScreen}
          personal={personal}
          MateriaPrima={MateriaPrima}
        />
      )}

      <Dialog
        visible={showDialogRM}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <RequisaMaterialCrud
          idIngreso={requisaToShow}
          setIngresoToShow={setRequisaToShow}
          showDialog={showDialogRM}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          editable={false}
        />
      </Dialog>
    </div>
  );
};
  
export default ListadoSalidasMaterialesEnc;
  
